import { Component, EventEmitter, Input, OnInit, OnChanges, OnDestroy, SimpleChanges, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { CommonService } from 'src/app/providers/common.service';
import { apiLinks } from '../../../../core/api-links/api-links';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PaymentStatusComponent } from '../payment-status/payment-status.component';

@Component({
  selector: 'app-vericheck-ach',
  templateUrl: './vericheck-ach.component.html',
  styleUrls: ['./vericheck-ach.component.scss']
})
export class VericheckAchComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectedPayaOption: any;
  @Input() selectedMode: any;
  @Input() vericheckTransaction$: Observable<any>;
  @Input() vericheckAddAchTransaction$: Observable<any>;
  @Input() vericheckReset$: Observable<any>;
  @Input() parentCloudposForm: any;
  @Input() selectedTpn: any;
  @Input() steamTagsForm: any;
  @Input() isEnableTag: any;
  @Input() fortInvoice: any;
  @Input() isFortellisEnabled: any;
  @Input() isAddAchVericheck = false;
  @Input() consumerId?: string | null;
  @Input() isMerchantBillingContext = false;
  @Input() buildVericheckHsmTokenUrl?: (hsmLookupTxId: string) => string;
  @Input() achAlternateCardsCount: number | null = null;
  @Input() isfromRunASale = false;
  @Input() cardsLoading = false;
  @Input() hideMaskedAchClear = false;
  @Input() validateParentPaymentFields?: () => boolean;
  tagValues: any = {};
  @Output() vericheckFormData = new EventEmitter<any>();
  @Output() getExstingCustomerPayload = new EventEmitter<string>();
  @Output() getConsumerDetail = new EventEmitter<any>();
  @Output() clearUnMaskedAlternateCard = new EventEmitter<void>();
  @Output() addBankCompleted = new EventEmitter<any>();
  @Input() isAddBank: Boolean = false;

 
  vericheckForm: UntypedFormGroup;
  submitted = false;
  maskedRoutingFormat = "000000000";
  maskedAccountFormat = "00000000000000000";
  accountTypeList = [{name:"Checking",id:"Checking"},{name:"Savings", id:"Savings"}];
  isMaskedCard:boolean=false;
  private patchedAchCardsCount = 0;
  private vericheckTokenizedId: string | null = null;
  private tokenizedHsmLookupTxId: string | null = null;
  private tokenizedAlternateVericheckId: string | null = null;
  private subscription: Subscription;
  private addAchSubscription: Subscription;
  private resetSubscription: Subscription;

  secCodeOptions = [
    { value: 'PPD', displayName: 'Personal' },
    { value: 'CCD', displayName: 'Business' }
  ];
  isAchAdded: string = '';
  private addBankModalRef: NgbModalRef | null = null;

  constructor(
    private fb: UntypedFormBuilder,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ngbModal: NgbModal
  ) { }

   public params: any = {
    ...(this.activatedRoute.snapshot.params || {}),
    ...(this.activatedRoute.snapshot.queryParams || {})
  };

  ngOnInit(): void {
    this.createForm();
    this.handlePayaOptionChange();
   if (this.vericheckTransaction$) {
      this.subscription = this.vericheckTransaction$.subscribe((res) => {
        /** Add-bank (manual entry only) uses `vericheckAddAchTransaction$`; ignore tokenized/HSM payloads here. */
        if (this.isAddAchVericheck) {
          return;
        }
        if (!res) {
          return;
        }
        if(this.isEnableTag == 1){
          this.tagValues = res.tagValues
        }
        /** Alternate ACH / HSM payloads must run before `isfromExstingPayload` so we patch + set token ids via `(res, res)` and do not call `onTransaction`. */
        if (res.isFromTokenized === true || res.isHsmDown === true) {
          this.patchTokenizedBankFromHsm(res, res);
          return;
        }
        if (res.isfromExstingPayload) {
          const hasHsmBankFields =
            (res.routingNumber != null && String(res.routingNumber).trim() !== '') ||
            (res.accountNumber != null && String(res.accountNumber).trim() !== '');
          if (hasHsmBankFields) {
            this.patchTokenizedBankFromHsm(res, res);
          }
          this.onTransaction(true);
          return;
        }
        if (res.isFromTransaction === true) {
          this.onTransaction();
        }
      });
    }
    if (this.vericheckAddAchTransaction$) {
      this.addAchSubscription = this.vericheckAddAchTransaction$.subscribe((res) => {
        if (!res?.isFromAddAchBank) {
          return;
        }
        if (this.isEnableTag == 1) {
          this.tagValues = res.tagValues;
        }
        this.onAddAchBankTransaction();
      });
    }
    if (this.vericheckReset$) {
      this.resetSubscription = this.vericheckReset$.subscribe((res) => {
        if (!res?.isReset) {
          return;
        }
        this.onVericheckReset();
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.addAchSubscription?.unsubscribe();
    this.resetSubscription?.unsubscribe();
    this.addBankModalRef?.dismiss();
  }

  private getAddBankErrMessage(err: any): string {
    if (!err) {
      return 'Transaction failed';
    }
    if (typeof err.message === 'string' && err.message) {
      return err.message;
    }
    const m = err?.error?.message ?? err?.error?.error;
    return typeof m === 'string' && m ? m : 'Transaction failed';
  }

  /** Same pattern as `paya-ach`: `PaymentStatusComponent` with spinner then `isAchAdded` success/failure UI */
  private openVericheckAddBankModal(): void {
    window.scroll(0, 0);
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
    };
    this.addBankModalRef = this.ngbModal.open(PaymentStatusComponent, ngbModalOptions);
    this.addBankModalRef.componentInstance.isLoading = true;
    this.addBankModalRef.result.then(
      () => this.onAddBankModalFinished(),
      () => this.onAddBankModalFinished()
    );
  }

  private onAddBankModalFinished(): void {
    if (this.isAchAdded === 'true') {
      this.onVericheckReset();
      if (this.isMerchantBillingContext) {
        this.addBankCompleted.emit({ success: true });
      } else {
        this.router.navigate(['/consumer-list/list']);
      }
    }
    this.isAchAdded = '';
    this.addBankModalRef = null;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedPayaOption']) {
      this.handlePayaOptionChange();
    }
  }

  handlePayaOptionChange() {
    const personalValue = this.selectedPayaOption == 1 ? 'TEL' : 'PPD';
    
    // Update options with correct display names and values
    this.secCodeOptions = [
      { value: personalValue, displayName: 'Personal' },
      { value: 'CCD', displayName: 'Business' }
    ];

    // Update form value if necessary to match the new Personal value
    if (this.vericheckForm) {
      const currentVal = this.vericheckForm.get('secCode').value;
      if (currentVal === 'TEL' && personalValue === 'PPD') {
        this.vericheckForm.get('secCode').setValue('PPD');
      } else if (currentVal === 'PPD' && personalValue === 'TEL') {
        this.vericheckForm.get('secCode').setValue('TEL');
      }
    }
  }

  private readonly manualRoutingValidators = [
    Validators.required,
    Validators.minLength(9),
    Validators.pattern(/^[0-9]+$/),
  ];
  private readonly manualAccountValidators = [
    Validators.required,
    Validators.minLength(4),
    Validators.maxLength(17),
    Validators.pattern(/^[0-9]+$/),
  ];
  private readonly maskedBankValidators = [
    Validators.required,
    Validators.minLength(9),
    Validators.pattern(/^[0-9*]+$/),
  ];
  private readonly maskedAccountValidators = [
    Validators.required,
    Validators.minLength(4),
    Validators.maxLength(17),
    Validators.pattern(/^[0-9*]+$/),
  ];

  private readonly minAlphanumericChars = (min: number): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value == null || value === '') {
        return null;
      }
      const alphanumericCount = (String(value).match(/[a-zA-Z0-9]/g) || []).length;
      return alphanumericCount >= min ? null : { minAlphanumeric: true };
    };
  };

  createForm() {
    this.vericheckForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9 ,.']+$/),
        this.minAlphanumericChars(2),
        Validators.maxLength(25),
      ]],
      routingNumber: ['', this.manualRoutingValidators],
      accountNumber: ['', this.manualAccountValidators],
      secCode: ['PPD', [Validators.required]],
      accountType: ['Checking', [Validators.required]],
      description: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9 ]+$/),
        Validators.maxLength(30),
      ]],
    });
  }

  /** Restore editable bank fields after HSM/masked flow (reset or manual entry). */
  private enableManualBankFields(): void {
    const routingCtrl = this.vericheckForm.get('routingNumber');
    const accountCtrl = this.vericheckForm.get('accountNumber');
    routingCtrl?.setValidators(this.manualRoutingValidators);
    accountCtrl?.setValidators(this.manualAccountValidators);
    routingCtrl?.enable({ emitEvent: false });
    accountCtrl?.enable({ emitEvent: false });
    routingCtrl?.updateValueAndValidity({ emitEvent: false });
    accountCtrl?.updateValueAndValidity({ emitEvent: false });
  }

  get f() { return this.vericheckForm.controls; }

  /** Count for "Cards" button (parent input and/or last tokenized patch). */
  get achCardsCountForButtons(): number {
    let fromInput = 0;
    if (this.achAlternateCardsCount != null && this.achAlternateCardsCount !== undefined) {
      const n = Number(this.achAlternateCardsCount);
      fromInput = Number.isFinite(n) ? n : 0;
    }
    return Math.max(fromInput, this.patchedAchCardsCount || 0);
  }

  onSubmit() {
    this.submitted = true;
    if (this.vericheckForm.invalid) {
      return;
    }
  }

  onVericheckReset() {
    this.submitted = false;
    this.clearTokenizedSaleContext();
    this.isMaskedCard = false;
    this.patchedAchCardsCount = 0;
    this.vericheckForm.reset();
    this.enableManualBankFields();
    this.vericheckForm.markAsPristine();
    this.vericheckForm.markAsUntouched();
    this.selectedPayaOption == 1 ? this.vericheckForm.get('secCode')?.setValue('TEL') : this.vericheckForm.get('secCode')?.setValue('PPD'); 
    this.vericheckForm.get('accountType')?.setValue('Checking');
  }

  private resolveVericheckTokenId(row: any): string | null {
    if (row == null || typeof row !== 'object') {
      return null;
    }
    const raw = row.providerId ?? row.vericheck_id ?? row.payaId ?? row.paya_id;
    if (raw == null || raw === '') {
      return null;
    }
    const s = String(raw).trim();
    return s === '' ? null : s;
  }

  private clearTokenizedSaleContext(): void {
    this.vericheckTokenizedId = null;
    this.tokenizedHsmLookupTxId = null;
    this.tokenizedAlternateVericheckId = null;
  }

  /** Parent calls this after getHsmToken for run-as-sale with a stored bank token (same HSM shape as Paya ACH). */
  patchTokenizedBankFromHsm(data: any, runaSaledata?: any): void {
    if (!this.vericheckForm || data == null) {
      return;
    }
    const d: any = data;
    const routingMasked =
      d.routingNumber ?? d.routing_number ?? d.routing ?? '';
    const accountMasked =
      d.accountNumber ?? d.account_number ?? d.account ?? '';
    if (String(routingMasked).trim() === '' && String(accountMasked).trim() === '') {
      return;
    }
    const meta = runaSaledata ?? {};
    if (!meta.isHsmDown) {
      const altVid =
        meta.providerId ??
        meta.vericheck_id ??
        data.providerId ??
        data.vericheck_id;
      if (altVid != null && String(altVid).trim() !== '') {
        this.tokenizedAlternateVericheckId = String(altVid).trim();
      }
      const hsmLookup =
        meta.payaId ??
        meta.paya_id ??
        meta.hsmLookupTxId ??
        data.payaId ??
        data.paya_id ??
        data.hsmLookupTxId;
      if (hsmLookup != null && String(hsmLookup).trim() !== '') {
        this.tokenizedHsmLookupTxId = String(hsmLookup).trim();
      }
      const legacy = this.resolveVericheckTokenId(meta) ?? this.resolveVericheckTokenId(data);
      if (legacy) {
        this.vericheckTokenizedId = legacy;
      }
      if (!this.tokenizedHsmLookupTxId && legacy) {
        this.tokenizedHsmLookupTxId = legacy;
      }
      if (!this.tokenizedAlternateVericheckId && legacy) {
        this.tokenizedAlternateVericheckId = legacy;
      }
    }
    const nameFromKey =
      d.name != null && String(d.name).trim() !== ''
        ? String(d.name).trim()
        : '';
    const first = d.firstName ?? d.first_name;
    const last = d.lastName ?? d.last_name;
    const name =
      nameFromKey ||
      [first, last].filter(Boolean).join(' ').trim() ||
      runaSaledata?.chName ||
      '';
    const desc =
      (d.description && String(d.description).trim()) ||
      this.vericheckForm.get('description')?.value ||
      '';
    const acctType = d.accountType ?? d.account_type ?? 'Checking';
    this.vericheckForm.patchValue({
      routingNumber: routingMasked,
      accountNumber: accountMasked,
      accountType: acctType || 'Checking',
      name,
      description: desc,
    });
    const routingCtrl = this.vericheckForm.get('routingNumber');
    const accountCtrl = this.vericheckForm.get('accountNumber');
    if (routingCtrl) {
      routingCtrl.setValidators(this.maskedBankValidators);
      routingCtrl.updateValueAndValidity({ emitEvent: false });
      routingCtrl.disable({ emitEvent: false });
    }
    if (accountCtrl) {
      accountCtrl.setValidators(this.maskedAccountValidators);
      accountCtrl.updateValueAndValidity({ emitEvent: false });
      accountCtrl.disable({ emitEvent: false });
    }
    const cl = meta?.cardsLength ?? meta?.cards_length ?? data?.cardsLength ?? data?.cards_length;
    this.patchedAchCardsCount =
      cl != null && String(cl).trim() !== '' && !Number.isNaN(Number(cl)) ? Number(cl) : 0;
    this.isMaskedCard = true;
  }

  /** Clear masked routing/account, re-enable manual entry, reset tokenized ids (same idea as Paya `clearUnMaskedAlternateCardInfo`). */
  clearVericheckMaskedAlternateCardInfo(): void {
    if (!this.vericheckForm) {
      return;
    }
    this.clearTokenizedSaleContext();
    this.enableManualBankFields();
    this.submitted = false;
    this.vericheckForm.patchValue(
      { routingNumber: '', accountNumber: '', name: '', description: '' },
      { emitEvent: false }
    );
    ['routingNumber', 'accountNumber', 'name', 'description'].forEach((field) => {
      const ctrl = this.vericheckForm.get(field);
      ctrl?.markAsPristine();
      ctrl?.markAsUntouched();
      ctrl?.updateValueAndValidity({ emitEvent: false });
    });
    this.isMaskedCard = false;
    this.patchedAchCardsCount = 0;
    this.clearUnMaskedAlternateCard.emit();
  }

  private formatAmtForAch(amount: string): string {
    if (!amount) return '0';
    const digits = (amount || '').toString().replace(/[^0-9]/g, '');
    return digits || '0';
  }

  /** Prefer values returned from GET getHsmToken (decrypted payload shape may vary). */
  private normalizeDescriptionFromHsm(hsmData: any, fallback: string): string {
    const raw = hsmData?.description ?? hsmData?.txnDescription;
    if (raw == null || String(raw).trim() === '') {
      return fallback;
    }
    let d = String(raw).trim();
    if (d.length > 30) {
      d = d.slice(0, 30);
    }
    return d;
  }

  private normalizeEntryClassFromHsm(hsmData: any, fallback: string): string {
    const raw =
      hsmData?.entryClass ??
      hsmData?.standard_entry_class ??
      hsmData?.secCode ??
      hsmData?.standardEntryClass;
    if (raw == null || raw === '') {
      return fallback;
    }
    const s = String(raw).trim().toUpperCase();
    const allowed = ['PPD', 'CCD', 'TEL', 'WEB'];
    return allowed.includes(s) ? s : fallback;
  }

  private cleanRouteParam(value: any): string {
    if (value == null || value === '' || value === 'null') {
      return '';
    }
    return String(value);
  }

  getExstingPayload(accountNumber: string): void {
    this.getExstingCustomerPayload.emit(accountNumber);
  }

  getConsumersTokenDetail(): void {
    /** Add-bank and run-as-sale: manual entry / session token only — do not fetch saved cards on focus. */
    if (this.isAddAchVericheck) {
      return;
    }
    this.getConsumerDetail.emit('reopen');
  }

  private onTransaction(isUpdate = false) {
    this.submitted = true;
    if (this.vericheckForm.invalid) {
      this.vericheckForm.markAllAsTouched();
      return;
    }
    if (this.isEnableTag == 1 && this.steamTagsForm && this.steamTagsForm.invalid) {
      return;
    }
    if (this.validateParentPaymentFields && !this.validateParentPaymentFields()) {
      return;
    }
    const amt = this.parentCloudposForm?.get(['paymentInfo', 'amt'])?.value || '';
    let email = this.parentCloudposForm?.get(['paymentInfo', 'email'])?.value || '';
    const phoneObj = this.parentCloudposForm?.get(['paymentInfo', 'phone'])?.value || null;
    let phone = phoneObj?.e164Number || phoneObj || '';
    const routeEmail = this.cleanRouteParam(this.params?.email);
    const routePhone = this.cleanRouteParam(this.params?.phone);
    if (this.isAddAchVericheck) {
      if (!email && routeEmail) {
        email = routeEmail;
      }
      if (!phone && routePhone) {
        phone = routePhone;
      }
    }
    this.submitted = false;
    const isTokenizedVericheckSale =
      !this.isAddAchVericheck &&
      this.isMaskedCard &&
      (!!this.vericheckTokenizedId || !!this.tokenizedAlternateVericheckId);

    /** Only masked (stored / HSM-patched) flows need the existing-consumer + optional HSM round-trip. Manual entry posts directly to commonTransactionApi. */
    const needsExistingCustomerLookup =
      !this.isAddAchVericheck &&
      !isTokenizedVericheckSale &&
      this.isMaskedCard;

    if (!isUpdate && needsExistingCustomerLookup) {
      this.vericheckFormData.emit({ showPaymentModal: true });
      this.getExstingPayload(this.vericheckForm.get('accountNumber')?.value);
      return;
    }
    this.vericheckFormData.emit({ showPaymentModal: !this.isAddAchVericheck });
    let { formattedDateTime: posRequestDate, formattedTime: posRequestTime } = this.commonService.getFormattedDateTime();

    const params: any = {
      amt: this.formatAmtForAch(amt),
      tpn: this.selectedTpn?.tpn || this.selectedTpn,
      routingNumber: this.vericheckForm.get('routingNumber')?.value,
      accountNumber: this.vericheckForm.get('accountNumber')?.value,
      accountType: this.vericheckForm.get('accountType')?.value,
      name: this.vericheckForm.get('name')?.value,
      entryClass: this.vericheckForm.get('secCode')?.value,
      txDate: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      txTime: moment().utc().format("HH:mm:ss"),
      posRequestDate: posRequestDate,
      posRequestTime: posRequestTime,
      hostResponseDate: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      hostResponseTime: moment().utc().format("HH:mm:ss"),
      email: email || "",
      phone: phone || "",
      description: this.vericheckForm.get('description')?.value,
      paymentMode: "Vericheck ACH - ",
      transactionType: this.selectedMode.id,
      fortInvoice: this.fortInvoice,
      isMerchantBilling: this.params?.isMerchantBilling == 'true' || false,
      isFortellisEnabled :  this.isFortellisEnabled
    };
    if (this.isEnableTag == 1 ) {
      if (!isEmpty(this.tagValues.tagLabels) && !isEmpty(this.tagValues.tagValues)) {
            params.tagLabel = this.tagValues.tagLabels;
            params.tagValue = this.tagValues.tagValues;
          }
    }

    const useHsmThenTokenized =
      !this.isAddAchVericheck &&
      this.isMaskedCard &&
      typeof this.buildVericheckHsmTokenUrl === 'function' &&
      (!!this.vericheckTokenizedId || !!this.tokenizedAlternateVericheckId);

    if (useHsmThenTokenized) {
      const hsmTxId = this.tokenizedHsmLookupTxId || this.vericheckTokenizedId;
      const vericheckIdForBody = this.tokenizedAlternateVericheckId || this.vericheckTokenizedId;
      if (!hsmTxId || !vericheckIdForBody) {
        this.submitted = false;
        this.vericheckFormData.emit({
          showError: true,
          err: {
            message: 'Missing stored bank ids. Reselect the alternate bank and try again.'
          }
        });
        return;
      }
      const hsmUrl = this.buildVericheckHsmTokenUrl(hsmTxId);
      if (!hsmUrl) {
        this.submitted = false;
        this.vericheckFormData.emit({ showError: true, err: { message: 'Unable to build HSM request.' } });
        return;
      }
      const formDesc = this.vericheckForm.get('description')?.value;
      const formEntry = this.vericheckForm.get('secCode')?.value;
      this.commonService.getCommonHttpClientParams(hsmUrl).subscribe({
        next: (hsmData: any) => {
          if (isEmpty(hsmData) || hsmData?.isHsmDown) {
            this.submitted = false;
            this.vericheckFormData.emit({
              showError: true,
              err: { message: 'Unable to load bank token (HSM).' }
            });
            return;
          }
          const description = this.normalizeDescriptionFromHsm(hsmData, formDesc);
          const entryClass = this.vericheckForm.get('secCode')?.value;
          const submitBody: any = {
            ...params,
            description,
            entryClass,
            amt: this.formatAmtForAch(amt),
            vericheckId: vericheckIdForBody
          };
          this.commonService.postCommonHttpClient(apiLinks.achnxapis.tokenizedTransaction, submitBody).subscribe({
            next: (res) => {
              this.clearTokenizedSaleContext();
              this.vericheckFormData.emit({ vericheckSuccess: true, txResponse: res, params });
            },
            error: (err) => {
              this.submitted = false;
              this.vericheckFormData.emit({ showPaymentModal: true, showError: true, err });
            }
          });
        },
        error: (err) => {
          this.submitted = false;
          this.vericheckFormData.emit({ showPaymentModal: true, showError: true, err });
        }
      });
      return;
    }

    this.commonService.postCommonHttpClient(apiLinks.achnxapis.commonTransactionApi, params).subscribe({
      next: (res) => {
        this.vericheckFormData.emit({ vericheckSuccess: true, txResponse: res, params });
      },
      error: (err) => {
        this.submitted = false;
        this.vericheckFormData.emit({ showPaymentModal: true, showError: true, err });
      }
    });
  }

  /** Add-bank: dedicated ACH route (not commonTransactionApi / process-ach-payments) */
  private onAddAchBankTransaction() {
    this.submitted = true;
    if (this.vericheckForm.invalid) {
      this.vericheckForm.markAllAsTouched();
      this.vericheckFormData.emit({ showError: true, isClientValidation: true });
      return;
    }
    if (this.isEnableTag == 1 && this.steamTagsForm && this.steamTagsForm.invalid) {
      this.vericheckFormData.emit({ showError: true, isClientValidation: true });
      return;
    }
    const amt = this.parentCloudposForm?.get(['paymentInfo', 'amt'])?.value || '';
    let email = this.parentCloudposForm?.get(['paymentInfo', 'email'])?.value || '';
    const phoneObj = this.parentCloudposForm?.get(['paymentInfo', 'phone'])?.value || null;
    let phone = phoneObj?.e164Number || phoneObj || '';
    const routeEmail = this.cleanRouteParam(this.params?.email);
    const routePhone = this.cleanRouteParam(this.params?.phone);
    if (!email && routeEmail) {
      email = routeEmail;
    }
    if (!phone && routePhone) {
      phone = routePhone;
    }
    if (this.validateParentPaymentFields && !this.validateParentPaymentFields()) {
      if (this.isMerchantBillingContext) {
        this.vericheckFormData.emit({ showError: true, isClientValidation: true });
      }
      return;
    }
    if (!this.isMerchantBillingContext) {
      this.openVericheckAddBankModal();
    }
    let { formattedDateTime: posRequestDate, formattedTime: posRequestTime } = this.commonService.getFormattedDateTime();
    const consumerId = this.cleanRouteParam(this.params?.consumerId || this.consumerId);
    const body: any = {
      amt: this.formatAmtForAch(amt),
      tpn: this.selectedTpn?.tpn || this.selectedTpn,
      routingNumber: this.vericheckForm.get('routingNumber')?.value,
      accountNumber: this.vericheckForm.get('accountNumber')?.value,
      accountType: this.vericheckForm.get('accountType')?.value,
      name: this.vericheckForm.get('name')?.value,
      entryClass: this.vericheckForm.get('secCode')?.value,
      txDate: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      txTime: moment().utc().format("HH:mm:ss"),
      posRequestDate: posRequestDate,
      posRequestTime: posRequestTime,
      hostResponseDate: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      hostResponseTime: moment().utc().format("HH:mm:ss"),
      email: email || "",
      phone: phone || "",
      description: this.vericheckForm.get('description')?.value,
      paymentMode: "Vericheck ACH - ",
      transactionType: this.selectedMode.id,
      fortInvoice: this.fortInvoice,
      isMerchantBilling: this.isMerchantBillingContext || this.params?.isMerchantBilling == 'true' || false,
      isFortellisEnabled: this.isFortellisEnabled,
      consumerId: consumerId || undefined,
      isAddAchBank: true
    };
    if (this.isEnableTag == 1) {
      if (!isEmpty(this.tagValues.tagLabels) && !isEmpty(this.tagValues.tagValues)) {
        body.tagLabel = this.tagValues.tagLabels;
        body.tagValue = this.tagValues.tagValues;
      }
    }
    this.commonService.postCommonHttpClient(apiLinks.achnxapis.commonAddBankApi, body).subscribe({
      next: (res) => {
        if (this.isMerchantBillingContext) {
          this.submitted = false;
          this.addBankCompleted.emit({ success: true, response: res });
          return;
        }
        if (!this.addBankModalRef) {
          return;
        }
        const code = res?.data?.status;
        this.addBankModalRef.componentInstance.isLoading = false;
        if (code === 'ACCEPTED') {
          this.submitted = false;
          this.addBankModalRef.componentInstance.isAchAdded = this.isAchAdded = 'true';
          return;
        }
        this.submitted = false;
        this.addBankModalRef.componentInstance.isAchAdded = this.isAchAdded = 'false';
        this.addBankModalRef.componentInstance.errorMessage = code || res?.message || 'Declined';
      },
      error: (err) => {
        this.submitted = false;
        if (this.isMerchantBillingContext) {
          this.vericheckFormData.emit({ showError: true, err });
          return;
        }
        if (!this.addBankModalRef) {
          this.vericheckFormData.emit({ showPaymentModal: true, showError: true, err });
          return;
        }
        this.addBankModalRef.componentInstance.isLoading = false;
        this.addBankModalRef.componentInstance.isAchAdded = this.isAchAdded = 'false';
        this.addBankModalRef.componentInstance.errorMessage = this.getAddBankErrMessage(err);
      }
    });
  }
}
